module.exports = __webpack_public_path__ + "img/ararat-reg-logo.8d0e5a14.png";